module.exports = __webpack_public_path__ + "2305578c.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/logo.png
// module id = 1746
// module chunks = 2 17 18 28 31 34 35